import axios from "@/config/httpConfig";
// 邮件模板保存图片
export function uploadMailPic(data) {
    return axios.post("/template/uploadMailPic", data);
}
